import { render, staticRenderFns } from "./catalogue-list.vue?vue&type=template&id=86490eca&scoped=true&"
import script from "./catalogue-list.vue?vue&type=script&lang=js&"
export * from "./catalogue-list.vue?vue&type=script&lang=js&"
import style0 from "./catalogue-list.vue?vue&type=style&index=0&id=86490eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86490eca",
  null
  
)

export default component.exports